import { AxiosError } from 'axios';
import { useState } from 'react';

import { Button } from '../../../cdl/Button/Button';
import { useDrawer } from '../../../cdl/Drawer/useDrawer.hook';
import { useToasts } from '../../../cdl/Toast/useToasts';
import { translate } from '../../../common/helpers/translate.helper';
import { IconPlus } from '../../../common/icons/cdl/Plus';
import { UserServerError, useUserInvite } from '../../detail/hooks/useUserInvite';

import { InviteUserForm, InviteUserFormProps } from './InviteUserForm';

interface InviteUserProps {
    onSuccess: () => void;
}

export const InviteUser = ({ onSuccess }: InviteUserProps) => {
    const [error, setError] = useState<UserServerError>();
    const inviteUserMutation = useUserInvite();
    const { addToast } = useToasts();

    const handleSubmit: InviteUserFormProps['onSubmit'] = (userInviteMessage) => {
        inviteUserMutation.mutate(userInviteMessage, {
            onSuccess: () => {
                onSuccess();
                addToast(translate('user.invitationToasts.success'));
            },
            onError: (error: AxiosError<any>) => {
                if (error.response) {
                    setError({
                        email: userInviteMessage.email,
                        errorCode: error.response?.data.errorCode,
                    });
                }
            },
        });
    };

    return <InviteUserForm onSubmit={handleSubmit} error={error} />;
};

export const InviteUserButton = () => {
    const { push, pop } = useDrawer();

    return (
        <Button
            emphasis="high"
            LeadingIcon={IconPlus}
            onClick={() => {
                const drawerId = push({
                    header: { title: translate('user.inviteTitle') },
                    content: <InviteUser onSuccess={() => pop(drawerId)} />,
                });
            }}
        >
            {translate('users.invite')}
        </Button>
    );
};
